export default __webpack_public_path__ + "static/media/x.01822f3f.png";